import React, { useState, useEffect } from "react";
import {
    Button,
    ComposedModal,
    ModalBody,
    ModalHeader,
    ModalFooter
  } from "carbon-components-react";
  import "./MultiSessionLogout.scss";
  import { AppMsg } from "../utils";

//This allows a handle to the modal setOpen state function and doLogout function.
let handleSetOpen;
let handleDoLogout;

const defineLogoutHandlerFunctions = (setOpen, doLogout) => {
  handleSetOpen = setOpen;
  handleDoLogout = doLogout;
}

const hasMultipleUsersSessions = () => {
  return fetch('../../ui/logoutHandler/userSessionDetails')
    .then((resp) => resp.json())
    .then(data => {
      return data.hasMultipleUserSessions;
    })
}

const logoutAllSessionsForUser = () => {
  fetch('../../ui/logoutHandler/logoutAllSessionsForCurrentUser')
    .then(() => {
      //Handle main logout function from client.
      handleDoLogout();
    });
}

export const handleLogout = () => {
  hasMultipleUsersSessions().then(hasMultipleSessions => {
    if (hasMultipleSessions) {
      handleSetOpen(true);
    } else {
      handleDoLogout();
    }
  });
}

export const MultiSessionLogoutModal = (props) => {
 
  const [open, setOpen] = useState(false);

  useEffect(() => {
    defineLogoutHandlerFunctions(setOpen, props.doLogout);
  });


  const handleEscKey = (event) => {
    if (event.keyCode === 27) {
      //Close Warning Model if it is showing
      setOpen(false);
    }
  }
  // Add event listeners
  React.useEffect(() => {
    window.addEventListener('keydown', handleEscKey);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', handleEscKey)
    }
  }, []);

  return (
    <ComposedModal 
      selectorPrimaryFocus=".bx--btn--primary"
      preventCloseOnClickOutside={true}
      open={open} 
      onClose={() => setOpen(false)}
      >
      <ModalHeader
        closeClassName="bx-close-model-custom"
        label={AppMsg.getMessage(AppMsg.APP_MULTI_LOGOUT_OPEN_SESSIONS)}
      >
        {AppMsg.getMessage(AppMsg.APP_LOGOUT)}
      </ModalHeader>
      <ModalBody>
        <p>
        {AppMsg.getMessage(AppMsg.APP_MULTI_LOGOUT)}
        </p>
        </ModalBody>
      <ModalFooter
        className="multiSessionLogoutFooter"
      >
        <Button
          kind="secondary"
          onClick={() => { setOpen(false); }}>
          {AppMsg.getMessage(AppMsg.APP_CANCEL)}
        </Button>
        <Button
          kind="secondary"
          onClick={() => {  
            setOpen(false); 
            logoutAllSessionsForUser();
          }}>
          {AppMsg.getMessage(AppMsg.APP_MULTI_LOGOUT_ALL_SESSIONS)}
        </Button>
        <Button
          kind="primary"
          onClick={() => {
            setOpen(false);
            props.doLogout();
          }}>
          {AppMsg.getMessage(AppMsg.APP_MULTI_LOGOUT_THIS_SESSION)}
        </Button>
      </ModalFooter>
    </ComposedModal>
  )
}
